// extracted by mini-css-extract-plugin
module.exports = {"s1k9z937":"s1k9z937","expand-s1k9z937":"expand-s1k9z937"};